module.exports = __webpack_public_path__ + "img/slider_14.d699b4d0.jpg";